<template lang="pug">
  .panel-page-white.body-1
    .panel-white.mx-auto
      FormErrorAlert(
        v-if="message"
        @dismiss="message = ''"
        heading="Error"
        :message="message"
      )
      PageHeader Multiple ID Search
      form(autocomplete="off")
        .search-panel
          p
            | Provide at least two identification numbers to view multiple purchasers' transactions in chronological order. Multiple ID search can be used
            | for up to 5 identification numbers.
          h4.panel-heading Identification Number
          .row.align-items-center(v-for="(id, idx) in ids" :key="`id_${idx}`")
            .col-8.col-md-5.col-lg-5
              .form-group
                label(for=`multipleId${id}`) Identification Number
                input.form-control(id=`multipleId${id}` @input="ids.splice(idx, 1, $event.target.value)" :value="ids[idx]")
            .col-4
              a(href="" @click.prevent="deleteId(idx)" v-show="ids && ids.length > 2") Remove
          button.btn.btn-primary(@click.prevent="ids.push('')" v-show="ids && ids.length < 5") + Add Another ID
          h4.panel-heading.mt-4 Date Range
          .row
            .col-12.col-md-8.col-lg-2
              .form-group
                label(for="start-date") Start Date
                Datepicker(
                  input-id="start-date"
                  input-class="form-control"
                  v-model="startDate"
                )
            .col-12.col-md-8.col-lg-2
              .form-group
                label(for="end-date") End Date
                Datepicker(
                  input-id="end-date"
                  input-class="form-control"
                  v-model="endDate"
                )
          a.btn.btn-primary(href="" @click.prevent="search") Search
</template>

<script>
import PageHeader from '@/components/PageHeader'
import FormErrorAlert from '@/components/FormErrorAlert'
import Datepicker from '@/components/Datepicker'
import { loadForm, clearForm } from '@/lib/formstore'
import { parse, differenceInCalendarDays, subDays, format } from 'date-fns/esm'
import axios from '@/lib/axios'
import { waitReport, globalError } from '@/lib/utils'

export default {
  name: 'MultipleIdSearch',
  data() {
    return {
      message: '',
      ids: ['', ''],
      endDate: format(new Date(), 'MM/dd/yyyy'),
      startDate: format(subDays(new Date(), 89), 'MM/dd/yyyy'),
    }
  },
  computed: {},
  methods: {
    search() {
      if (
        this.ids.filter(s => !!s).length < 2 ||
        !this.startDate ||
        !this.endDate
      ) {
        this.message =
          'Please include a minimum of two identifications and a date range to search.'
        window.scrollTo(0, 0)
        return
      } else if (
        differenceInCalendarDays(
          parse(this.endDate, 'MM/dd/yyyy', new Date()),
          parse(this.startDate, 'MM/dd/yyyy', new Date()),
        ) > 89
      ) {
        this.message = 'Date range may be a maximum of 90 days.'
        window.scrollTo(0, 0)
        return
      }
      axios()
        .post('/api/multiple_id/search', {
          idNumbers: this.ids,
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then(resp => {
          let id = resp.data.id
          waitReport(id, {
            name: 'multiple_id_results',
            params: { id },
          })
        })
        .catch(err => globalError(err))
    },
    deleteId(index) {
      this.ids.splice(index, 1)
    },
  },
  components: {
    PageHeader,
    FormErrorAlert,
    Datepicker,
  },
  mounted: loadForm('multipleid', 'ids', 'startDate', 'endDate'),
  beforeRouteLeave(to, _from, next) {
    if (to.name !== 'multiple_id_results') clearForm('multipleid')
    next()
  },
}
</script>

<style lang="scss" scoped>
.panel-white {
  width: 1007px;
}
.search-panel {
  border: 1px solid #e6e6e6;
  padding: 1rem;
}

.panel-heading {
  border-bottom: 2px solid #e6e6e6;
  margin-bottom: 0.8rem;
}
</style>
